import { chatLinks } from '../Chat/links';
import { guestLinks } from '../GuestArea/links';
import { menteesLinks } from '../Mentees/links';
import { mentorProfileLinks } from '../MentorProfile/links';
import { mentorsLinks } from '../Mentors/links';
import { mentorSessionsLinks } from '../MentorSessions/links';
import pathwaysLinks from '../Pathways/links';
import { profileLinks } from '../ProfileSettings/links';
import { profileTasksLinks } from '../ProfileTasks/links';
import { sessionsLinks } from '../SessionsScheduling/links';

export const resolveMapDeepLink = (target: string, params: URLSearchParams) => {
  // Temporary fix for avoiding clashes with invitation short urls.
  if (target.length === 6) {
    window.location.href = `/i/${target}`;
    return null;
  }

  const idParam = parseInt(params.get('id') ?? '', 10);
  switch (target) {
    // used by: main app rails
    case 'login':
      return guestLinks.authentication();

    // used by: main app rails
    case 'reset_password':
      return guestLinks.resetPassword();

    case 'email_confirmation':
      return guestLinks.emailVerification();

    // used by: main app rails
    case 'feedback':
      return profileLinks.feedbackForm();

    // used by: main app rails
    case 'careers':
      return pathwaysLinks.root();

    // used by: main app rails
    case 'career_detail':
      return pathwaysLinks.showOccupation(idParam);

    // used by: main app rails
    case 'messages':
      return chatLinks.root();

    // used by: main app rails
    case 'profile_tasks':
      return profileTasksLinks.root();

    // used by: main app rails
    case 'profile_task_details':
      return profileTasksLinks.taskDetails(idParam);

    // used by: main app rails
    case 'mentees':
      return idParam ? menteesLinks.menteeProfile(idParam) : menteesLinks.root();

    // used by: main app rails
    case 'mentors':
      return idParam ? mentorsLinks.mentorDetails(idParam) : mentorsLinks.root();

    case 'mentor_trainings':
      return mentorProfileLinks.training();

    // used by: session scheduler
    case 'sessions':
      return sessionsLinks.root();

    // used by: session scheduler
    case 'session_details':
      return sessionsLinks.sessionDetails(idParam);

    // used by: session scheduler
    case 'request_session':
      return sessionsLinks.scheduleRequest(idParam);

    // used by: session scheduler
    case 'session_feedback':
      return idParam
        ? sessionsLinks.sessionFeedback(idParam)
        : sessionsLinks.sessionPublicFeedback(params.get('token') ?? '');

    // used by: session scheduler
    case 'session_confirmation':
      params.delete('id');
      params.set('sessionId', idParam.toString());
      return sessionsLinks.confirmRegistration();

    // used by: session scheduler
    case 'mentorship_session_details':
      return mentorSessionsLinks.sessionDetails(idParam);

    // used by: session scheduler
    case 'mentorship_session_report':
      return mentorSessionsLinks.sessionDetails(idParam, { tab: 'report' });
  }
  return null;
};
